import Plantilla from "./plantilla";

export default function SeguroDeAuto() {
  return (
    <Plantilla>
      <div className="ejemplo">
        <p>Seguro de Auto</p>
      </div>
    </Plantilla>
  );
}
